import { type FC, type ReactNode } from 'react'

import { Icon, Typography } from '@matillion/component-library'
import classNames from 'classnames'

import classes from './ErrorMessage.module.scss'

interface Props {
  className?: string
  children?: ReactNode
}

const ErrorMessage: FC<Props> = ({ className, children }) => {
  return (
    <div
      className={classNames(classes.ErrorMessage, className)}
      data-testid="error-message"
    >
      <Icon.Error className={classes.ErrorMessage__Icon} />
      <Typography>{children}</Typography>
    </div>
  )
}

export default ErrorMessage
